import { render, staticRenderFns } from "./B2bDetail.vue?vue&type=template&id=2e774c39&scoped=true&"
import script from "./B2bDetail.vue?vue&type=script&lang=js&"
export * from "./B2bDetail.vue?vue&type=script&lang=js&"
import style0 from "./B2bDetail.vue?vue&type=style&index=0&id=2e774c39&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e774c39",
  null
  
)

export default component.exports